<template>
    <div>
        <v-row v-for="link in field.value" :key="link.id" no-gutters align="center" class="pl-1">
            <icon icon="Table" small/>
            <span class="pl-3">
                <a
                    :href="link.link"
                    class="body-2 d-flex align-center"
                    target="_blank"
                >
                    <div>
                        {{ $t(link.title) }}
                    </div>
                    <div class="ml-1 d-flex">
                        <icon
                            size="11"
                            icon="ExternalLink"
                        />
                    </div>
                </a>
            </span>
        </v-row>
    </div>
</template>

<script>

import {formatCustomFieldValue} from "../../../composables/use-custom-fields";
import PersonAvatar from "../../PersonAvatar.vue";

export default {
    name: "ReportsLinkField",
    components: {PersonAvatar},
    methods: {formatCustomFieldValue},
    props: {
        relatedObject: {
            type: Object,
            required: true
        },
        field: {
            type: Object,
            required: true
        }
    },
}

</script>

<style scoped lang="scss">
</style>